// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sash-wrap-line {
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 1s;
}
.sash-wrap-line .line {
  display: block;
  height: 100%;
  width: 1px;
  background-color: rgba(0, 0, 0, .2);
}
.sash-wrap-line.active {
  background-color: lightgray;
}
.sash-wrap-line.inactive {
  transition: none;
}

.action-sash-wrap {
  width: 1px;
  position: relative;
  height: 100%;
  display: flex;
  align-items: start;
  justify-content: center;
  background-color: rgba(0, 0, 0, .2);
}

.action-sash-wrap.pane-horizontal {
  flex-direction: column;
}


.action-sash-wrap .react-pane-split-action:hover {
  color: rgba(0, 0, 0, .8);
}

.action-sash-wrap.pane-horizontal {
  width: 100%;
  height: 1px;
  align-items: end;
}

html, body {
  margin: 0px;
  padding: 0px;
}

.react-split--horizontal > div[role="Resizer"]::before {
  content: "";
  display: block;
  height: 7px;
  top: -3px;
  width: 100%;
  position: absolute;
}

.react-split--vertical > div[role="Resizer"]::before {
  content: "";
  display: block;
  width: 7px;
  height: 100%;
  position: absolute;
  right: -3px;
}
`, "",{"version":3,"sources":["webpack://./src/lib/components/style.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,YAAY;EACZ,UAAU;EACV,mCAAmC;AACrC;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,uBAAuB;EACvB,mCAAmC;AACrC;;AAEA;EACE,sBAAsB;AACxB;;;AAGA;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,cAAc;EACd,WAAW;EACX,SAAS;EACT,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,WAAW;AACb","sourcesContent":[".sash-wrap-line {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 1s;\n}\n.sash-wrap-line .line {\n  display: block;\n  height: 100%;\n  width: 1px;\n  background-color: rgba(0, 0, 0, .2);\n}\n.sash-wrap-line.active {\n  background-color: lightgray;\n}\n.sash-wrap-line.inactive {\n  transition: none;\n}\n\n.action-sash-wrap {\n  width: 1px;\n  position: relative;\n  height: 100%;\n  display: flex;\n  align-items: start;\n  justify-content: center;\n  background-color: rgba(0, 0, 0, .2);\n}\n\n.action-sash-wrap.pane-horizontal {\n  flex-direction: column;\n}\n\n\n.action-sash-wrap .react-pane-split-action:hover {\n  color: rgba(0, 0, 0, .8);\n}\n\n.action-sash-wrap.pane-horizontal {\n  width: 100%;\n  height: 1px;\n  align-items: end;\n}\n\nhtml, body {\n  margin: 0px;\n  padding: 0px;\n}\n\n.react-split--horizontal > div[role=\"Resizer\"]::before {\n  content: \"\";\n  display: block;\n  height: 7px;\n  top: -3px;\n  width: 100%;\n  position: absolute;\n}\n\n.react-split--vertical > div[role=\"Resizer\"]::before {\n  content: \"\";\n  display: block;\n  width: 7px;\n  height: 100%;\n  position: absolute;\n  right: -3px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
